interface ApiErrorDetail {
  type: string;
  loc: string[];
  msg: string;
  input?: any;
  ctx?: {
    max_length?: number;
    min_length?: number;
  };
}

interface ApiErrorResponse {
  detail: string | ApiErrorDetail[];
}

/**
 * Универсальная обработка ошибок API
 * @param error - объект ошибки от axios
 * @returns строка с описанием ошибки для пользователя
 */
export const handleApiError = (error: any): string => {
  // Если нет response, возвращаем общую ошибку
  if (!error?.response?.data) {
    return 'Произошла неизвестная ошибка. Попробуйте еще раз.';
  }

  const errorData: ApiErrorResponse = error.response.data;
  const { detail } = errorData;

  // Если detail - это строка, возвращаем её
  if (typeof detail === 'string') {
    return detail;
  }

  // Если detail - это массив объектов с деталями ошибок
  if (Array.isArray(detail)) {
    const errorMessages: string[] = [];

    detail.forEach((errorDetail: ApiErrorDetail) => {
      const { loc, msg, type, ctx } = errorDetail;

      // Получаем название поля из loc (обычно последний элемент)
      const fieldName = loc[loc.length - 1];

      // Формируем понятное сообщение для пользователя
      let userMessage = '';

      switch (type) {
        case 'string_too_long':
          userMessage = `Поле "${getFieldDisplayName(fieldName)}" слишком длинное. Максимум ${ctx?.max_length || 25} символов.`;
          break;
        case 'string_too_short':
          userMessage = `Поле "${getFieldDisplayName(fieldName)}" слишком короткое. Минимум ${ctx?.min_length || 1} символов.`;
          break;
        case 'value_error':
          userMessage = `Некорректное значение в поле "${getFieldDisplayName(fieldName)}".`;
          break;
        case 'type_error':
          userMessage = `Некорректный тип данных в поле "${getFieldDisplayName(fieldName)}".`;
          break;
        case 'missing':
          userMessage = `Поле "${getFieldDisplayName(fieldName)}" обязательно для заполнения.`;
          break;
        default:
          userMessage = msg || `Ошибка в поле "${getFieldDisplayName(fieldName)}".`;
      }

      errorMessages.push(userMessage);
    });

    return errorMessages.join(' ');
  }

  // Если detail имеет другой формат, возвращаем общую ошибку
  return 'Произошла ошибка при обработке запроса. Попробуйте еще раз.';
};

/**
 * Получает отображаемое название поля для пользователя
 * @param fieldName - техническое название поля
 * @returns понятное название для пользователя
 */
const getFieldDisplayName = (fieldName: string): string => {
  const fieldNames: Record<string, string> = {
    email: 'Email',
    password: 'Пароль',
    username: 'Имя пользователя',
    name: 'Имя',
    phone: 'Телефон',
    nonude: 'No nude/Lifestyle',
    tt: 'TikTok',
    lingerie: 'Lingerie',
    lite_nude: 'Light Nudes',
    full_nude: 'Full Nude',
  };

  return fieldNames[fieldName] || fieldName;
};
